import { Box, Typography, useTheme } from '@mui/material';

import SectionTitle from './SectionTitle';

interface Props {
  disabled?: boolean;
}

const contents = [
  '協議條款',
  '1. 患者同意遵守醫院的所有規章制度以及任何醫院代表發布的指令。一旦醫生根據其判斷為患者簽發任何形式的出院指令，患者必須遵守醫生的指示。',
  '2. 患者/擔保人必須在雙方約定的截止日期前向醫院支付全部醫療費用。如果患者無法支付全部醫療費用，醫院將保留患者/擔保人在住院期間支付的押金，並在韓國司法管轄範圍內對患者/擔保人提起訴訟。',
  '3. 如果患者未加入韓國醫療保險計劃，他/她必須擁有具備財務資源的韓國擔保人，或者根據醫院規定存入（$）或以上的押金，該押金可用於支付醫療總費用。然而，超過押金的任何金額必須由患者或擔保人在醫院規定的付款截止日期內支付，並承擔連帶責任。',
  '4. 未納入健康保險支付範圍的一般醫療費用（醫療行為、醫療用品、醫療材料、醫療設備等）需由患者和擔保人共同承擔責任支付。',
  '5. 患者同意對因患者直接或間接造成的醫院及其工作人員和/或設備/家具的任何損害承擔責任，並在出院前承擔修復或更換此類損失或損害的財務責任。',
  '6. 醫院不對患者/患者賓客/患者監護人的個人財產/貴重物品/金錢在患者住院期間的遺失、遺失、損壞或被竊負責。',
  '7. 如果入住非普通病房，患者需承擔醫院提供的特殊食物及病房和食物的額外費用。',
  '8. 對於在患者住院/手術/程序/治療/護理期間或之後發生的任何問題，患者不得對醫院採取任何法律行動，醫院醫療錯誤除外。',
];

const PatientsRights = (props: Props) => {
  const { disabled } = props;
  const { palette } = useTheme();

  return (
    <>
      <SectionTitle title="入院時" />
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 10px auto',
        }}
      >
        <Typography
          sx={{
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '24px',
            whiteSpace: 'pre-wrap',
          }}
        >
          如果您對本文件有任何疑問或不理解其中任何部分，或者需要翻譯，請向您的醫生或其他醫療提供者諮詢。
        </Typography>
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '0px auto 10px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '20px auto 20px auto',
        }}
      >
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '24px',
            whiteSpace: 'pre-wrap',
            color: `${palette.primary.main}`,
          }}
        >
          我已閱讀並理解上述聲明
        </Typography>
      </Box>
    </>
  );
};

export default PatientsRights;
